module.exports = __webpack_public_path__ + "img/MACU TEA.c9921471.svg";